{//scope
/****************************************************
* Configuration - will be moved to app
****************************************************/
const minPossibleRepayment = 9;
const possibleTerms = [6, 12, 18, 24, 30, 36, 48, 60, 72];
const presetRepresentiveAPR = 0.099;
const minRepaymentLabel = "oder ab";
const showMatrixLabel = "Ratentabelle anzeigen";
const showLegalLabel = "per Spedition";
const closeLabel = "schließen";
const termsUnit = "Monate";
const termText = "/ Monat";
const taxHint = "inkl. MwSt."
const loanAmountLabel = "Nettodarlehensbetrag";
const introText = "Die Ware kann zu folgenden Konditionen finanziert werden";
const matrixFooterInformation = `Alle Berechnungen ohne Versicherung.<br />Das Rechenbeispiel entspricht dem repräsentativen Beispiel gemäß §6a Preisangabenverordnung`;
const matrixColumnHeaders = ['Laufzeit','Monatliche Rate','Gesamtbetrag','Effektiver Jahreszins','Sollzinssatz (jährl., gebunden)'];
const legalInfomationHtml = `<div class="shogun-root" data-shogun-id="5fe316a125d23b005060bd8e" data-shogun-site-id="4ee339bd-a323-42e4-bab9-453b4c972198" data-shogun-page-id="5fe316a125d23b005060bd8e" data-shogun-page-version-id="6213603d804a6000d91c7e06" data-shogun-platform-type="shopify" data-shogun-variant-id="6213603d804a6000d91c7f43" data-region="main"> 
<div class="shg-box-vertical-align-wrapper">
<div class="shg-box shg-c    " id="s-2e46ee15-cb1d-458b-bb73-91fc18e977e5">
<div class="shg-box-overlay"></div>
<div class="shg-box-content">
<div id="s-68eea6d5-a995-46a8-8985-30fb09290a00" class="shg-c  ">
<div class="shg-rich-text shg-default-text-content">
<p style="text-align: center;"><em><img src="https://i.shgcdn.com/3f557e89-5470-452f-a51e-c791dba0611d/-/format/auto/-/preview/3000x3000/-/quality/lighter/" alt="MotorLand Lieferung per Spedition" /><strong><span style="font-family: Roboto; font-size: 20px;">Informationen zu Lieferung per Spedition:</span></strong></em></p>
</div>
</div>
</div>
</div>
</div>
<div class="shg-box-vertical-align-wrapper">
<div class="shg-box shg-c    " id="s-8da933a9-ddc0-4917-9680-8ff49c18f9fc">
<div class="shg-box-overlay"></div>
<div class="shg-box-content">
<div class="shg-c  " id="s-3c9ffa79-3452-4420-ac24-24d88069fdb2">
<div class="spedition-row shg-row" data-col-grid-mode-on="">
<div class="shg-c-lg-6 shg-c-md-6 shg-c-sm-6 shg-c-xs-12">
<div class="shg-c  " id="s-1dbbca1d-db68-4d9c-b264-3f21e3261f9d">
<div class="spedition-row shg-row" data-col-grid-mode-on="">
<div class="spedition-col shg-c-lg-6 shg-c-md-6 shg-c-sm-6 shg-c-xs-12">
<div class="shg-box-vertical-align-wrapper">
<div class="shg-box shg-c    " id="s-36b86bda-11b1-4f57-ad7b-048200c84e5f">
<div class="shg-box-overlay"></div>
<div class="shg-box-content">
<div class="shg-c shogun-image-container    shg-align-center" style="opacity: 1;" id="s-6a2dda21-b8b0-41a9-b426-a2f882553681"><img src="https://i.shgcdn.com/cb1e7835-22bd-41bf-8e2c-6d45a77e93fc/-/format/auto/-/preview/3000x3000/-/quality/lighter/" width="" height="70px" style="border-radius: 0px;" alt="" class="shogun-image " /></div>
<script type="text/javascript">// <![CDATA[
  window.SHOGUN_IMAGE_ELEMENTS = window.SHOGUN_IMAGE_ELEMENTS || new Array();
  window.SHOGUN_IMAGE_ELEMENTS.push({ hoverImage: '', uuid: 's-6a2dda21-b8b0-41a9-b426-a2f882553681' })
// ]]></script>
<div id="s-003f005f-2fcc-405c-a66c-635c33ee530d" class="shg-c  shg-align-center">
<div class="shogun-heading-component">
<h6>Anliefertag mit Ihnen vereinbart</h6>
</div>
</div>
<div id="s-e5606fc5-e79c-4ed1-92eb-7aa5f8bf7c92" class="shg-c  ">
<div class="shg-rich-text shg-default-text-content">
<p><span style="font-family: Roboto;">Unsere Spedition wird vor Anlieferung telefonisch einen Termin mit Ihnen vereinbaren. Dies erfolgt meist <strong>einen Tag vor der geplanten Anlieferung</strong>.</span></p>
<p><span style="font-family: Roboto;">Bitte hinterlegen Sie darum im Bestellprozess eine Telefonnummer, unter der Sie <strong>tagsüber erreichbar</strong> sind.</span></p>
</div>
</div>
</div>
</div>
</div>
</div>
<div class="spedition-col shg-c-lg-6 shg-c-md-6 shg-c-sm-6 shg-c-xs-12">
<div class="shg-box-vertical-align-wrapper">
<div class="shg-box shg-c    " id="s-7b4aab32-1c5c-4a19-bc7a-e91d1c56af72">
<div class="shg-box-overlay"></div>
<div class="shg-box-content">
<div class="shg-c shogun-image-container    shg-align-center" style="opacity: 1;" id="s-e8d6a010-b282-4430-983d-6aad8b92c291"><img src="https://i.shgcdn.com/957637b5-fa28-457c-a3d6-658dd98a9871/-/format/auto/-/preview/3000x3000/-/quality/lighter/" width="" height="70px" alt="" class="shogun-image " /></div>
<script type="text/javascript">// <![CDATA[
  window.SHOGUN_IMAGE_ELEMENTS = window.SHOGUN_IMAGE_ELEMENTS || new Array();
  window.SHOGUN_IMAGE_ELEMENTS.push({ hoverImage: '', uuid: 's-e8d6a010-b282-4430-983d-6aad8b92c291' })
// ]]></script>
<div id="s-c85d8bbe-d77d-452a-9d31-b5f84ad81cb5" class="shg-c  shg-align-center">
<div class="shogun-heading-component">
<h6>Hinweis zu Inseln und Packstationen</h6>
</div>
</div>
</div>
</div>
</div>
<div id="s-8fc68945-34de-48ef-99b6-a94cb341f7a0" class="shg-c  ">
<div class="shg-rich-text shg-default-text-content">
<p style="text-align: center; line-height: 24px;"><span style="font-family: Roboto;">Unsere Spedition liefert an Adressen, die über das <strong>deutsche Straßennetz erreichbar</strong> sind, <strong>nicht</strong> jedoch an Lieferanschriften auf <strong>deutschen Inseln<sup>1</sup></strong> und an <strong>DHL-Packstationen</strong>.</span></p>
</div>
</div>
</div>
</div>
</div>
</div>
<div class="shg-c-lg-6 shg-c-md-6 shg-c-sm-6 shg-c-xs-12">
<div class="shg-c  " id="s-e59a5c1c-d781-4d24-a4ad-0999755fe6fd">
<div class="spedition-row shg-row" data-col-grid-mode-on="">
<div class="spedition-col shg-c-lg-6 shg-c-md-6 shg-c-sm-6 shg-c-xs-12">
<div class="shg-box-vertical-align-wrapper">
<div class="shg-box shg-c    " id="s-c7e3ff99-4b2a-45a2-bc7e-15df8bd5e473">
<div class="shg-box-overlay"></div>
<div class="shg-box-content">
<div class="shg-c shogun-image-container    shg-align-center" style="opacity: 1;" id="s-15b32e5d-2714-48c2-a294-77fc8d0bcefb"><img src="https://i.shgcdn.com/6b85a103-b06b-4be8-b15f-cca58bb371ab/-/format/auto/-/preview/3000x3000/-/quality/lighter/" width="" height="70px" alt="" class="shogun-image " /></div>
<script type="text/javascript">// <![CDATA[
  window.SHOGUN_IMAGE_ELEMENTS = window.SHOGUN_IMAGE_ELEMENTS || new Array();
  window.SHOGUN_IMAGE_ELEMENTS.push({ hoverImage: '', uuid: 's-15b32e5d-2714-48c2-a294-77fc8d0bcefb' })
// ]]></script>
<div id="s-f4b8ede5-f3cd-41fe-830a-4dcf75f8dcc9" class="shg-c  shg-align-center">
<div class="shogun-heading-component">
<h6>mögliche Liefertage</h6>
</div>
</div>
<div id="s-43757720-be18-4c6f-934e-20f09aa1644c" class="shg-c  ">
<div class="shg-rich-text shg-default-text-content">
<p style="text-align: center; line-height: 24px;"><span style="font-family: Roboto;">Unsere Spedition liefert <strong>Montag bis Freitag</strong></span>.</p>
</div>
</div>
</div>
</div>
</div>
</div>
<div class="spedition-col shg-c-lg-6 shg-c-md-6 shg-c-sm-6 shg-c-xs-12">
<div class="shg-c shogun-image-container    shg-align-center" style="opacity: 1;" id="s-aa8211d2-9234-4d7c-a554-5c769c7b20ec"><img src="https://i.shgcdn.com/15680a6d-b9e1-4aac-93c7-165f4a02f4b0/-/format/auto/-/preview/3000x3000/-/quality/lighter/" width="" height="70px" alt="" class="shogun-image " /></div>
<script type="text/javascript">// <![CDATA[
  window.SHOGUN_IMAGE_ELEMENTS = window.SHOGUN_IMAGE_ELEMENTS || new Array();
  window.SHOGUN_IMAGE_ELEMENTS.push({ hoverImage: '', uuid: 's-aa8211d2-9234-4d7c-a554-5c769c7b20ec' })
// ]]></script>
<div class="shg-box-vertical-align-wrapper">
<div class="shg-box shg-c    " id="s-b05592d0-136f-45f7-a6f9-2349fe9cbe16">
<div class="shg-box-overlay"></div>
<div class="shg-box-content">
<div id="s-1b60061b-fc00-4b53-a8c3-45a0ad81714d" class="shg-c  shg-align-center">
<div class="shogun-heading-component">
<h6>Lieferung bis Bordsteinkante</h6>
</div>
</div>
<div id="s-65309c33-624f-4331-b686-35c54246d536" class="shg-c  ">
<div class="shg-rich-text shg-default-text-content">
<p style="text-align: center; line-height: 24px;"><span style="font-family: Roboto;">Die Belieferung erfolgt bis <strong>Bordsteinkante</strong></span>.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div id="s-d3599143-3c6f-46f7-8dcc-dca338018a94" class="shg-c  ">
<div class="shg-rich-text shg-theme-text-content">
<p><span style="font-size: 8px;"><sup>1</sup>Diese sind: 18565 (Hiddensee), 25845 (Südfall), 25849 (Pellworm), 25859 (Hooge), 25863 (Langeneß), 25869 (Gröde), </span><span style="font-size: 8px;">25938 (Föhr), 25946 (Amrum), 25980 (Sylt), 25996 (Sylt), 25997 (Sylt), 25999 (Sylt), 26465 (Langeoog), 26474 (Spiekeroog), </span><span style="font-size: 8px;">26486 (Wangerooge), 26548 (Norderney), 26571 (Juist), 26579 (Baltrum), 26757 (Borkum), 27498 (Helgoland), 27499 (Neuwerk), 78266 (Büsingen)</span></p>
</div>
</div>
</div>
</div>
</div>
<script type="text/javascript" src="https://cdn.getshogun.com/5/6213603d804a6000d91c7f43.js" async=""></script>
</div>`;

// (!) D0 NOT add shop specific design here - add it to theme.
const modalClass = "dialogConainer";
const border = `border: 1px solid #CCC`;
const css = `
	.shippping .${modalClass} {display: none; position: absolute;${border};padding: 1rem; padding-top: 2rem; z-index: 300; background-color: #FFF; min-width: 10rem; max-width: 50rem; right: 5%; top: 50%;}
	@media (max-width: 768px) {.shippping .${modalClass} {left: 5%;}}
	.shippping .close {position: absolute; top: 0.5rem; right: 1rem; ${border}; padding: 2px 3px; cursor: pointer;}

	/*hbo - to be moved to theme*/
	.shippping .cents{top: -0.5em; font-size: 75%; position: relative; vertical-align:baseline;}
.shippping button {margin-top: 0;margin-bottom: 0; margin-left: 0;border: none; padding-left: 3px; padding-top: 0px; padding-bottom: 0px; background: none; font-size: 1em; text-decoration: underline;}

`;

/****************************************************
* Calculation
****************************************************/
const calcInterestRate = apr => apr == 0 ? 0 : (Math.pow((1 + apr), (1 / 12)) - 1) * 12;
class Tarif {
	constructor(term, representiveAPR) {
		this.term = term;
		this.representiveAPR = representiveAPR;
		this.interestRate = calcInterestRate(representiveAPR);
	}
	calculateRepayment(loanAmount) {
		let monthlyRepayment;
		if (this.representiveAPR != 0) {
			const simpleFactor = Math.pow(this.representiveAPR + 1, 1 / 12);
			const termFactor = Math.pow(simpleFactor, this.term);

			monthlyRepayment = loanAmount * termFactor / (termFactor - 1) * (simpleFactor - 1);
		} else {
			monthlyRepayment = loanAmount / term;
		}
		return monthlyRepayment >= minPossibleRepayment ? monthlyRepayment : null;
	}
}
class LoanOffer {
	constructor(loanAmount, tarif) {
		this.tarif = tarif;
		this.monthlyRepayment = tarif.calculateRepayment(loanAmount);
		this.totalPayment = this.monthlyRepayment ? this.monthlyRepayment * tarif.term : null;
	}
}
class LoanOfferMatrix {
	constructor(loanAmount, tarifs) {
		this.loanAmount = loanAmount;
		this.loanOffers = tarifs.map(tarif => new LoanOffer(loanAmount, tarif)).filter(offer => offer.monthlyRepayment != null);
		this.minRepayment = Math.min(...this.loanOffers.map(loanOffer => loanOffer.monthlyRepayment));
	}
}
const tarifs = possibleTerms.map(term => new Tarif(term, presetRepresentiveAPR));

const calculateOffers = loanAmount => {
	return tarifs.map(tarif => new Offer(tarif)).filter(offer => offer.monthlyRepayment != null);
}



/****************************************************
* Presentation
****************************************************/

const moneyFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
const twoDigitsFormatter = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });
const minRepayment2Html = minRepayment => {
	const integralPart = Math.floor(minRepayment);
	let fractionPart = Math.floor((minRepayment-integralPart) * 100);
	if(fractionPart < 0.5) {
		fractionPart = ",-"
	}
	else {
		if(fractionPart < 10) {
			fractionPart = '0'+fractionPart;
		}
		fractionPart = '<span class="cents">'+fractionPart+'</span>';
	}

}
let even = true;
const loanOffer2Html = offer => {
	const monthlyRepayment = moneyFormatter.format(offer.monthlyRepayment);
	const totalPayment = moneyFormatter.format(offer.totalPayment);
	const interestRate = twoDigitsFormatter.format(offer.tarif.interestRate * 100)
	even = !even;
	return`<tr class="${even ? 'even': 'odd'}">
		<td>${offer.tarif.term} ${termsUnit}</td>
		<td>${monthlyRepayment}</td>
		<td>${totalPayment}</td>
		<td>${offer.tarif.representiveAPR * 100} %</td>
		<td>${interestRate} %</td>
	</tr>`
}
const matrix2Html = matrix => {
	const headerCells = matrixColumnHeaders.map(header => `<th>${header}</th>`).join('');
	const offersHtml = matrix.loanOffers.map(offer => loanOffer2Html(offer)).join('');
	return `<table class="repayment-matrix-values"><thead><tr>${headerCells}</tr></thead><tbody>${offersHtml}</tbody></table>`;
}

const controlButtons = `
	<button data-modal="shippping-legal-information">${showLegalLabel}</button>`;
const closeButton = `<span class="close">${closeLabel}</span>`;

const calculation2Html = matrix => {
	const loanAmount = moneyFormatter.format(matrix.loanAmount);
	return `
		<div id="shippping-legal-information" class="legal-information  ${modalClass}">${legalInfomationHtml+closeButton}</div>
		${controlButtons}
	`;
}

const activateButtons = () => {
	document.querySelectorAll(".shippping button").forEach(button => {
		button.addEventListener('click', () => {
			const node = document.getElementById(button.dataset.modal);
    		node.style.display = "block";
 		});
	});
	document.querySelectorAll(".shippping .close").forEach(close => {
		close.addEventListener('click', (event) => {
			console.log("clockM");
    		document.querySelectorAll("."+modalClass).forEach(modal => modal.style.display = "none");
 		});
	});
}
const anchor = document.querySelector('script[data-shipping]');
const inject = html => {
	const style = document.createElement('style');
	style.type = 'text/css';
	if(style.styleSheet)
		style.styleSheet = css;
	else
		style.appendChild(document.createTextNode(css));

	document.querySelector('head').appendChild(style);
	const container = document.createElement('div');
	container.classList.add("shippping");
//  	container.outerHTML = "<div class=\"shippping\" style=\"display: inline-block;\"></div>";
	container.innerHTML=html;

	anchor.parentNode.insertBefore(container, anchor);
	activateButtons();
};

/****************************************************
* Execution
****************************************************/
// const price2 = (Shopify.locale === "de") ? parseFloat(document.querySelector('meta[property="og:price:amount"]').getAttribute('content').replace(',', '.').replace('.', '')):0; // TODO: search more convenient way!; reuse in basket?
const price = anchor.dataset.shipping;
if(price > 100) {
	const matrix = new LoanOfferMatrix(price, tarifs);
	inject(calculation2Html(matrix));
}
}//scope

